import axios from "axios";
import { API } from "../api/constants";
import Raven from "raven-js";
import history from "../history";
import { CONFIG } from "../constants/api";
import CookieStorageService from "./CookieStorageService";
import RollbarErrorTracking from "../utils/rollbarErrorTracking";

const cookieStorageService = CookieStorageService.getService();

const getClient = () => {
  const baseUrl = `${API}`;
  const options = {
    baseURL: baseUrl
  };
  const client = axios.create(options);
  // Add a request interceptor
  client.interceptors.request.use(
    requestConfig => requestConfig,
    requestError => {
      Raven.captureException(requestError);

      return Promise.reject(requestError);
    }
  );

  client.interceptors.request.use(
    config => {
      const token =
        localStorage.getItem("session") &&
        cookieStorageService.getAccessToken();
      if (token) {
        config.headers["Authorization"] = "Bearer " + token.access_token;
      }
      return config;
    },
    error => {
      Promise.reject(error);
    }
  );

  client.interceptors.response.use(
    response => {
      return response;
    },
    function(error) {
      if (error.response.status === 403) {
        if (error.response.data.error && !error.response.data.error.access) {
          cookieStorageService.clearAll();
          history.push("/authorization/login");
        }
      }

      if (error.response.status === 401) {
        cookieStorageService.clearAll();
        history.push("/authorization/login");
      }

      RollbarErrorTracking.logErrorInRollbar(error);

      return Promise.reject(error);
    }
  );

  return client;
};

class ApiClient {
  constructor(baseUrl = null) {
    this.client = getClient(baseUrl);
  }
  get(url, params = {}) {
    return this.client
      .get(url, { ...CONFIG, ...params })
      .then(response => response)
      .catch(error => Promise.reject(error));
  }
  delete(url, conf = CONFIG) {
    return this.client
      .delete(url, conf)
      .then(response => response)
      .catch(error => Promise.reject(error));
  }
  head(url, conf = CONFIG) {
    return this.client
      .head(url, conf)
      .then(response => response)
      .catch(error => Promise.reject(error));
  }
  options(url, conf = CONFIG) {
    return this.client
      .options(url, conf)
      .then(response => response)
      .catch(error => Promise.reject(error));
  }
  post(url, data = {}, conf = CONFIG) {
    return this.client
      .post(url, data, conf)
      .then(response => response)
      .catch(error => Promise.reject(error));
  }
  put(url, data = {}, conf = CONFIG) {
    return this.client
      .put(url, data, conf)
      .then(response => response)
      .catch(error => Promise.reject(error));
  }
  patch(url, data = {}, conf = CONFIG) {
    return this.client
      .patch(url, data, conf)
      .then(response => response)
      .catch(error => Promise.reject(error));
  }
}

export const RequestService = new ApiClient();
